import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { openGoogleLogin } from '@/lib/auth';
import { useAuth } from '@/providers/AuthProvider';
import logoVertical from '@/assets/images/Logo-vertical.png';
import {CustomButton} from '@/components/uiWrappers/button.tsx';
import GoogleLoginIcon from '@/assets/icons/googleLoginIcon.svg';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const { isLoading, isAuthenticated, userRole } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to their appropriate page
  useEffect(() => {
    if (!isLoading && isAuthenticated && userRole) {
      if (userRole === 'admin') {
        navigate({ to: '/admin', replace: true });
      } else {
        navigate({ to: '/access-denied', replace: true });
      }
    }
  }, [isLoading, isAuthenticated, userRole, navigate]);

  // Show loading spinner while authenticating
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen">
      {/* Left side - Login Form */}
      <div className="flex w-full lg:w-1/2 items-center justify-center bg-brand p-8">
        <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-10">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Admin Login
            </h1>
            <p className="text-muted-foreground text-sm">
              Access & Manage Quizzes, Articles and Users
            </p>
          </div>

          <div className="space-y-4">

            <CustomButton
              type="button"
              onClick={openGoogleLogin}
              variant={'outline'}
              size="lg"
              className="w-full rounded-full"
            >
              <img src={GoogleLoginIcon}
                   alt="Google Icon"
                   data-icon="inline-start"
              />
              Continue with Google
            </CustomButton>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-border"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-muted-foreground">
                  Authorized personnel only
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Logo */}
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center bg-white p-8">
        <div className="max-w-md">
          <img
            src={logoVertical}
            alt="Parenting First Logo"
            className="w-[250px] h-auto"
          />
        </div>
      </div>
    </div>
  );
}
